import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SignupService } from '@app-services/signup/signup.service';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { openTermsAndConditionsDialog, signup, socialMediaClicked } from '@app-core/components/home/home.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IliteModalComponent } from './modal/content.component';
import { TenantConstant } from '@app-constants/tenant.constant';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { UserService } from '@app-services/user/user.service';
import { SubscriptionService } from '@app-services/subscription/subscription.service';
import { jeeAdvancedPackages, jeePackages, neetPackages } from '@app-constants/app.constants';
import { openILITESignUpDialog, openTSDialog } from 'src/app/helpers/methods';

export function nextSlide() {
  
  const fs = document.getElementById("faculty-slider");
  //@ts-ignore
  const wds = fs.querySelectorAll(".item");
  let totalWidth = 0;
  for(let i =0, len = wds.length; i < len; i++) {
    //@ts-ignore
    totalWidth += wds[i].offsetWidth;
  }
  const pw = document.getElementById("IL_ilite-fs-parent").offsetWidth
  
  //@ts-ignore
  fs.style.left = Math.max(fs.offsetLeft - wds[0].offsetWidth, pw - totalWidth)  + "px"; 
}
export function prevSlide() { 
  const fs = document.getElementById("faculty-slider");
  //@ts-ignore
  const wd = fs.querySelectorAll(".item")[0].offsetWidth;
  fs.style.left = Math.min((fs.offsetLeft + wd), 0) + "px";
}
@Component({
  selector: 'app-ilite',
  templateUrl: './ilite.component.html',
  styleUrls: ['./ilite.component.scss']
})
export class IliteComponent implements OnInit {
  mobileNumberValid = false;
  signup = signup;
  openTermsAndConditionsDialog = openTermsAndConditionsDialog;
  socialMediaClicked = socialMediaClicked;
  openTSDialog = openTSDialog;
  openSignUpDialog = openILITESignUpDialog;
  nextFac = nextSlide;
  prevFac = prevSlide;
  tenant: any = TenantConstant.tenant;
  public mobileNumber: any = '';
  public PackageDetails:any = {}
  public neetPackages:any[] = neetPackages;
  public jeePackages:any[] = jeePackages;
  public jeeAdvancedPackages:any[] = jeeAdvancedPackages;
  constructor(public signUpService: SignupService, private dialog: MatDialog, private gaService: GAnalyticsService, public subscriptionservice : SubscriptionService, public modalservice:NgbModal,
    private titleService: Title,
    private metaService: Meta,
    public router: Router,
    public userService: UserService,) { 
  }
  ngOnInit(): void {
    if (this.tenant != 'infinitylearn') {
      this.router.navigate(['/']);
      return;
    }
    
    this.titleService.setTitle('NEET JEE Scholarship Test | Get Up to 100% Scholarship | ILITE by Infinity Learn and Sri Chaitanya');
    this.metaService.addTags([
      {name: 'keywords', content: 'neet scholarship test 2021,scholarship for neet coaching,iit jee scholarship test 2021,scholarship for iit jee coaching,neet course,iit jee course, neet 2022, neet 2023, neet 2024, iit jee 2022, iit jee 2023, iit jee 2023,neet scholarship test,iit jee scholarship test'},
      {name: 'description', content: 'Register for Biggest Scholarship exam ILITE and get up to 100% scholarship on courses for IIT-JEE, NEET. Learn from top faculties to help to crack the exam.'},
    ])
    //this.modalservice.open(IliteModalComponent)
  }
  ngAfterViewInit(){
  }
  openDefaultLoginDialog(numberAndIsd: any): void {
    this.openSignUpDialog(numberAndIsd);
  }
  registerNowTab(packageName: any){ 
  
    this.openTSDialog({
      message: 'One more step and you are all set',
        source: 'ILITE',
        hiddenFields: {hallticket: true},
        needPayment: true, 
        ILITE: true,
        grade: packageName?.grade,
        exam: packageName?.examName,
        subjects: packageName?.subjects
    })    
  }
  viewSyllabus(pkg: any) {
    const modalComp = this.modalservice.open(IliteModalComponent);
    modalComp.componentInstance.PackageDetails = pkg;
    //modalComp.result.finally(() => { registerNow.call(this, tests, examtype);  })    
  }
  copyFunction() {
    navigator.clipboard.writeText('https://infinitylearn.com/ilite');
    
    var tooltip = document.getElementById("myTooltip");
    tooltip.innerHTML = "Copied: " + 'https://infinitylearn.com/ilite';
  }
  
  outFunc() {
    var tooltip = document.getElementById("myTooltip");
    tooltip.innerHTML = "Copy to clipboard";
  }

  ngOnDestroy(){
  }
}
